module.exports = __webpack_public_path__ + "static/img/img-3.43017a51.png";